import React, { useState, useEffect } from 'react';
import { Container } from "reactstrap";
import PassGoLogo from "../assets/PassGoLogo.png";
import { WarningAmberRounded, LaunchRounded } from '@mui/icons-material';
import { Button } from '@mui/material';

const OpenInBrowser = () => {
  const appUrl = window.location.href.split('?')[0];
  const [deviceMessage, setDeviceMessage] = useState("");

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isChrome = /chrome/.test(userAgent) && !/edg/.test(userAgent);
    const isAndroidWithChrome = isAndroid && isChrome;
    const isAndroidWithoutChrome = isAndroid && !isChrome;

    if (isIOS) {
      setDeviceMessage("Estás usando un iPhone. Tocá los tres puntos (⋯) arriba a la derecha y seleccioná 'Abrir en Safari'.");
    } else if (isAndroidWithChrome) {
      setDeviceMessage("Estás en Android con Chrome. Tocá los tres puntos (⋯) arriba a la derecha y seleccioná 'Abrir en Chrome'.");
    } else if (isAndroidWithoutChrome) {
      setDeviceMessage("Estás en Android. Tocá los tres puntos (⋯) arriba a la derecha y seleccioná 'Abrir en tu navegador predeterminado'.");
    } else {
      setDeviceMessage("Estás navegando dentro de Instagram. Tocá los tres puntos (⋯) y seleccioná 'Abrir en el navegador'.");
    }
  }, []);

const openInExternalBrowser = () => {
  const newWindow = window.open(appUrl, '_blank');

  if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
    alert("No se pudo abrir el navegador. Tocá los tres puntos arriba a la derecha y seleccioná 'Abrir en el navegador'.");
  }
};

  return (
    <>
      <div className="passgo-navbar py-1" style={{
        backgroundColor: '#0b0060',
        width: '100%',
        height: '72px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1201,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', width: '100%' }}>
          <img src={PassGoLogo} width="75px" alt="PassGo logo" />
        </div>
      </div>

      <Container className="d-flex flex-column align-items-center justify-content-center"
        style={{
          minHeight: '100vh',
          maxWidth: '100%',
          backgroundColor: "#e6e6ff",
          padding: "10px",
          paddingTop: "25px"
        }}>
        <div className="p-4 shadow-sm rounded"
          style={{
            marginTop: "25px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: '#fff',
            width: '90%',
            borderRadius: "10px"
          }}>
          <div className="mb-4"
            style={{
              backgroundColor: "#e6e6ff",
              padding: "15px",
              borderRadius: "50%",
              width: "85px",
              height: "85px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
            <WarningAmberRounded style={{ color: "#0b0062", width: "60px", height: "60px" }} />
          </div>

          <p className="mb-3 text-center" style={{ fontSize: '16px', color: "#0b0062" }}>
            {deviceMessage}
          </p>

        </div>

        <div className="mt-3 text-muted">
          <small>© PassGo {new Date().getFullYear()}</small>
        </div>
      </Container>
    </>
  );
};

export default OpenInBrowser;
